import React from "react";
import { Navigate } from "react-router-dom";

/**
 * During pre-launch the /shop route redirects to the home page's
 * product section so we never present the product as buyable.
 * Once ecommerce is confirmed live, this file can be replaced with the
 * real single-product shop page.
 */
const Shop = () => <Navigate to="/#whats-in-the-box" replace />;

export default Shop;
